import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=2867fe46&scoped=true&"
import script from "./TransactionList.vue?vue&type=script&lang=js&"
export * from "./TransactionList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionList.vue?vue&type=style&index=0&id=2867fe46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867fe46",
  null
  
)

export default component.exports